import { QueryClient } from "@tanstack/react-query"

/**
 * Shared React Query client, created at module scope so the *same*
 * instance is used by both:
 *
 *   - `<QueryClientProvider>` in `providers.tsx` (components reading
 *     via `useQuery`/`useMutation`)
 *   - the TanStack Router context in `main.tsx`, so route
 *     `loader`/`beforeLoad` can `ensureQueryData(...)` against the same
 *     cache the components read from.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30 * 1000,
    },
    mutations: {
      retry: 0,
    },
  },
})
